import React from "react";

export default function Button({
    text,
    onClick,
    link,
    className,
}: {
    text: string;
    onClick?: () => void;
    link?: string;
    className: string;
}) {
    return (
        <>
            {onClick &&
                <button
                    type="button"
                    className={`rounded-full px-8 py-2.5 font-semibold text-purple shadow-sm ring-1 ring-inset
                    ring-purple transition-colors duration-300 delay-50 hover:bg-purple hover:text-white
                    ${className}
                    `}
                    onClick={onClick}
                >
                    {text}
                </button>        
            }
            {link && 
                <a
                    role="button"
                    className={`rounded-full px-8 py-2.5 font-semibold text-purple shadow-sm ring-1 ring-inset
                    ring-purple transition-colors duration-300 delay-50 hover:bg-purple hover:text-white
                    ${className}
                    `}
                    href={`${link}`}
                >
                    {text}
                </a>        
            }
        </>
    );
}
